import React, { FunctionComponent } from 'react';
import { View, Modal } from 'react-native';
import { LottieWrapper } from '../LottieWrapper';

import styles from './Loader.styles';
import { LoaderProps } from './Loader.types';

import animationData from '../../assets/lotties/loader3.json'

export const Loader: FunctionComponent<LoaderProps> = ({ 
  visible, 
  message = 'Chargement...' 
}) => {
  return (
    <Modal visible={visible} transparent>
      <View style={styles.overlay}>
        <View style={styles.container}>
          <View>
            <LottieWrapper
              source={animationData}
              autoPlay
              loop
              style={styles.lottie}
            />
          </View>
        </View>
      </View>
    </Modal>
  );
};
